import { useEffect, useState } from "react";
import { useNavigate, NavLink, Outlet } from "react-router-dom";
import {
  Menu,
  ChevronDown,
  LayoutDashboard,
  Users,
  KeyRound,
  Package,
  ClipboardList,
  FileText,
  Ticket,
  Settings,
} from "lucide-react";
import LogoImg from "../assets/images/GoelectroniX.png";

export default function DistributorPanel() {
  // Sidebar open by default for small screens (<640px)
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth < 640);
  const navigate = useNavigate();

  useEffect(() => {
    const authUserData = sessionStorage.getItem("authUserData");
    if (!authUserData) navigate("/login");

    // Toggle sidebar automatically when resizing
    const handleResize = () => {
      setSidebarOpen(window.innerWidth < 640);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [navigate]);

  const nav = [
    { path: "/dashboard", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
    { path: "/allretailers", icon: <Users size={18} />, label: "Retailers" },
    { path: "/keys", icon: <KeyRound size={18} />, label: "Keys" },
    { path: "/inventory", icon: <Package size={18} />, label: "Inventory" },
    { path: "/orders", icon: <ClipboardList size={18} />, label: "Orders" },
    { path: "/invoices", icon: <FileText size={18} />, label: "Invoices" },
    { path: "/support", icon: <Ticket size={18} />, label: "Support" },
    { path: "/account", icon: <Settings size={18} />, label: "Account" },
  ];

  const authUserString = sessionStorage.getItem("authUserData");
  const authUser = JSON.parse(authUserString);
  const loginUserID = authUser?.id;
  const LoginUserName = authUser?.business_name;
  const loginUserCode = authUser?.org_code;

  return (
    <div className="min-h-screen bg-white text-slate-900">
      {/* Top Bar */}
      <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: "#104191ff" }}>
        <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
          <div className="flex h-14 items-center justify-between">
            <div className="flex items-center gap-2">
              {/* Hide Menu button on small screens since sidebar is already visible */}
              <button
                onClick={() => setSidebarOpen((s) => !s)}
                className="rounded-xl p-2 hover:bg-white/10 focus:outline-none hidden sm:inline-flex"
              >
                <Menu className="text-white" size={20} />
              </button>

              <div className="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-2">
                <img src={LogoImg} alt="Logo" className="h-8 w-auto" />
                <span className="text-sm font-semibold tracking-wide text-white/80">
                  {LoginUserName}
                </span>
              </div>
            </div>

            <div className="flex items-center gap-1 sm:gap-2">
              <button
                onClick={() => navigate("/account")}
                className="group flex items-center gap-2 rounded-xl bg-white/10 px-2 py-1.5 text-white hover:bg-white/20"
              >
                <img src="/favicon.jpg" alt="Logo" className="h-6 w-6 rounded-full object-cover" />
                <span className="text-sm">{loginUserCode}</span>
                <ChevronDown size={16} className="opacity-80" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Layout */}
      <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
        <div className="grid grid-cols-12 gap-3 sm:gap-4 py-3 sm:py-4">
          {/* Sidebar for large screens */}
          {sidebarOpen && (
            <aside className="hidden sm:block col-span-12 sm:col-span-4 lg:col-span-2">
              <div className="sticky top-16 space-y-2 rounded-2xl p-2 bg-slate-50">
                {nav.map((n) => (
                  <NavLink
                    key={n.path}
                    to={n.path}
                    className={({ isActive }) =>
                      `flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm ${
                        isActive ? "bg-white font-semibold" : "hover:bg-white"
                      }`
                    }
                  >
                    <span className="text-slate-700">{n.icon}</span>
                    <span className="text-slate-700">{n.label}</span>
                  </NavLink>
                ))}
              </div>
            </aside>
          )}

          {/* Content */}
          <main
            className={
              sidebarOpen ? "col-span-12 sm:col-span-8 lg:col-span-10" : "col-span-12"
            }
          >
            <Outlet />
          </main>
        </div>
      </div>

      {/* Bottom Navigation for Small Screens */}
      {sidebarOpen && (
        <nav className="fixed bottom-0 left-0 right-0 z-50 overflow-x-auto bg-white border-t shadow sm:hidden">
          <div className="flex w-max">
            {nav.map((n) => (
              <NavLink
                key={n.path}
                to={n.path}
                className={({ isActive }) =>
                  `flex-shrink-0 w-1/4 flex flex-col items-center justify-center py-2 text-xs ${
                    isActive ? "text-blue-600" : "text-slate-600"
                  }`
                }
              >
                {n.icon}
                <span>{n.label}</span>
              </NavLink>
            ))}
          </div>
        </nav>
      )}

      <footer className="mt-4 sm:mt-6 border-t py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Goelectronix — Distributor Panel
      </footer>
    </div>
  );
}


// import { useEffect, useState } from "react";
// import { useNavigate, NavLink, Outlet } from "react-router-dom";
// import {
//   Menu, ChevronDown, LayoutDashboard, Users, KeyRound, Package,
//   ClipboardList, FileText, Ticket, Settings
// } from "lucide-react";
// import LogoImg from "../assets/images/GoelectroniX.png";

// export default function DistributorPanel() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const authUserData = sessionStorage.getItem("authUserData");
//     if (!authUserData) navigate("/login");
//   }, [navigate]);

//   const nav = [
//     { path: "/dashboard", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
//     { path: "/allretailers", icon: <Users size={18} />, label: "Retailers" },
//     { path: "/keys", icon: <KeyRound size={18} />, label: "Keys" },
//     { path: "/inventory", icon: <Package size={18} />, label: "Inventory" },
//     { path: "/orders", icon: <ClipboardList size={18} />, label: "Orders" },
//     // { path: "/payments", icon: <FileText size={18} />, label: "Payments" },  
//     { path: "/invoices", icon: <FileText size={18} />, label: "Invoices" },
//     { path: "/support", icon: <Ticket size={18} />, label: "Support" },
//     { path: "/account", icon: <Settings size={18} />, label: "Account" },
//   ];

//   const authUserString = sessionStorage.getItem("authUserData");
//   const authUser = JSON.parse(authUserString);
//   const loginUserID = authUser?.id;
//   const LoginUserName = authUser?.business_name;
//   const loginUserCode = authUser?.org_code;

//   return (
//     <div className="min-h-screen bg-white text-slate-900">
//       {/* Top Bar */}
//       <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: "#104191ff" }}>
//         <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//           <div className="flex h-14 items-center justify-between">
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => setSidebarOpen((s) => !s)}
//                 className="rounded-xl p-2 hover:bg-white/10 focus:outline-none"
//               >
//                 <Menu className="text-white" size={20} />
//               </button>
//               <div className="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-2">
//                 <img src={LogoImg} alt="Logo" className="h-8 w-auto" />
//                 <span className="text-sm font-semibold tracking-wide text-white/80">
//                   {LoginUserName}
//                 </span>
//               </div>
//             </div>

//             <div className="flex items-center gap-1 sm:gap-2">
//               <button
//                 onClick={() => navigate("/account")}
//                 className="group flex items-center gap-2 rounded-xl bg-white/10 px-2 py-1.5 text-white hover:bg-white/20"
//               >
//                 <img src="/favicon.jpg" alt="Logo" className="h-6 w-6 rounded-full object-cover" />
//                 <span className="text-sm">{loginUserCode}</span>
//                 <ChevronDown size={16} className="opacity-80" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Layout */}
//       <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-12 gap-3 sm:gap-4 py-3 sm:py-4">
//           {/* Vertical Sidebar for large screens */}
//           {sidebarOpen && (
//             <aside className="hidden sm:block col-span-12 sm:col-span-4 lg:col-span-2">
//               <div className="sticky top-16 space-y-2 rounded-2xl p-2 bg-slate-50">
//                 {nav.map((n) => (
//                   <NavLink
//                     key={n.path}
//                     to={n.path}
//                     className={({ isActive }) =>
//                       `flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm ${
//                         isActive ? "bg-white font-semibold" : "hover:bg-white"
//                       }`
//                     }
//                   >
//                     <span className="text-slate-700">{n.icon}</span>
//                     <span className="text-slate-700">{n.label}</span>
//                   </NavLink>
//                 ))}
//               </div>
//             </aside>
//           )}

//           {/* Content */}
//           <main className={sidebarOpen ? "col-span-12 sm:col-span-8 lg:col-span-10" : "col-span-12"}>
//             <Outlet />
//           </main>
//         </div>
//       </div>

//       {/* Horizontal Sidebar for small screens */}
// {sidebarOpen && (
//   <nav className="fixed bottom-0 left-0 right-0 z-50 overflow-x-auto bg-white border-t shadow sm:hidden">
//     <div className="flex w-max">
//       {nav.map((n) => (
//         <NavLink
//           key={n.path}
//           to={n.path}
//           className={({ isActive }) =>
//             `flex-shrink-0 w-1/4 flex flex-col items-center justify-center py-2 text-xs ${
//               isActive ? "text-blue-600" : "text-slate-600"
//             }`
//           }
//         >
//           {n.icon}
//           <span>{n.label}</span>
//         </NavLink>
//       ))}
//     </div>
//   </nav>
// )}


//       <footer className="mt-4 sm:mt-6 border-t py-4 text-center text-xs text-slate-500">
//         © {new Date().getFullYear()} Goelectronix — Distributor Panel
//       </footer>
//     </div>
//   );
// }


// import { useEffect, useState } from "react";
// import { useNavigate, NavLink, Outlet } from "react-router-dom";
// import {
//   Menu, Search, Bell, ChevronDown, LayoutDashboard, Users, KeyRound, Package,
//   ClipboardList, FileText, Ticket, Settings
// } from "lucide-react";
// import LogoImg from "../assets/images/GoelectroniX.png"; 

// const LOGO_URL = "https://via.placeholder.com/140x40?text=LOGO";

// export default function DistributorPanel() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const navigate = useNavigate();

//   // ✅ Protect dashboard
//   useEffect(() => {
//     const authUserData = sessionStorage.getItem("authUserData");
//     if (!authUserData) {
//       navigate("/login");
//     }
//   }, [navigate]);

//   const nav = [
//     { path: "/dashboard", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
//     { path: "/allretailers", icon: <Users size={18} />, label: "Retailers" },
//     { path: "/keys", icon: <KeyRound size={18} />, label: "Keys" },
//     { path: "/inventory", icon: <Package size={18} />, label: "Inventory" },
//     { path: "/orders", icon: <ClipboardList size={18} />, label: "Orders" },
//     { path: "/payments", icon: <FileText size={18} />, label: "Payments" },
//     // { path: "/balances", icon: <FileText size={18} />, label: "Balances" },
//     { path: "/support", icon: <Ticket size={18} />, label: "Support" },
//     { path: "/account", icon: <Settings size={18} />, label: "Account" },
//   ];

//   return (
//     <div className="min-h-screen bg-white text-slate-900">
//       {/* Top Bar */}
//       <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: "#104191ff" }}>
//         <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//           <div className="flex h-14 items-center justify-between">
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => setSidebarOpen((s) => !s)}
//                 className="rounded-xl p-2 hover:bg-white/10 focus:outline-none"
//               >
//                 <Menu className="text-white" size={20} />
//               </button>
//               {/* <img src={LOGO_URL} alt="Logo" className="h-8 w-auto" /> */}
//               <div className="flex flex-col items-start gap-1 sm:flex-row sm:items-center sm:gap-2">
//                 <img src={LogoImg} alt="Logo" className="h-8 w-auto" />
//                 <span className="text-sm font-semibold tracking-wide text-white/80">
//                   Distributor Panel
//                 </span>
//               </div>

//             </div>

//             <div className="flex items-center gap-1 sm:gap-2">
//               {/* <button className="relative rounded-xl p-2 hover:bg-white/10">
//                 <Bell className="text-white" size={18} />
//                 <span
//                   className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full text-[10px]"
//                   style={{ backgroundColor: "#E11D48", color: "#FFFFFF" }}
//                 >
//                   3
//                 </span>
//               </button> */}
//               <button
//                 onClick={() => navigate("/account")}
//                 className="group flex items-center gap-2 rounded-xl bg-white/10 px-2 py-1.5 text-white hover:bg-white/20"
//               >
//                 <img
//                   src="/favicon.jpg"   // <-- replace with your logo path
//                   alt="Logo"
//                   className="h-6 w-6 rounded-full object-cover"
//                 />
//                  <span className="text-sm hidden sm:block">Profile</span>
//                 <ChevronDown size={16} className="opacity-80" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Layout */}
//       <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-12 gap-3 sm:gap-4 py-3 sm:py-4">
//           {/* Sidebar */}
//           {sidebarOpen && (
//             <aside className="col-span-12 sm:col-span-4 lg:col-span-2">
//               <div className="sticky top-16 space-y-2 rounded-2xl p-2 bg-slate-50">
//                 {nav.map((n) => (
//                   <NavLink
//                     key={n.path}
//                     to={n.path}
//                     className={({ isActive }) =>
//                       `flex w-full items-center gap-2 rounded-xl px-3 py-2 text-sm ${
//                         isActive ? "bg-white font-semibold" : "hover:bg-white"
//                       }`
//                     }
//                   >
//                     <span className="text-slate-700">{n.icon}</span>
//                     <span className="text-slate-700">{n.label}</span>
//                   </NavLink>
//                 ))}
//               </div>
//             </aside>
//           )}

//           {/* Content */}
//           <main
//             className={sidebarOpen ? "col-span-12 sm:col-span-8 lg:col-span-10" : "col-span-12"}
//           >
//             {/* Nested page will load here */}
//             <Outlet />
//           </main>
//         </div>
//       </div>

//       <footer className="mt-4 sm:mt-6 border-t py-4 text-center text-xs text-slate-500">
//         © {new Date().getFullYear()} Goelectronix — Distributor Panel
//       </footer>
//     </div>
//   );
// }


// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom"; // <-- important
// import {
//   Menu, Search, Bell, ChevronDown, LayoutDashboard, Users, KeyRound, Package,
//   ClipboardList, FileText, Ticket, Settings
// } from "lucide-react";

// import Dashboard from "./Dashboard";
// import Retailers from "./Retailers";
// import Keys from "./Keys";
// import Account from "./Account";
// import Inventory from "./Inventory";
// import Orders from "./Orders";
// import Payments from "./Payment";
// import Balances from "./Balances";
// import Support from "./Support";

// const LOGO_URL = "https://via.placeholder.com/140x40?text=LOGO";

// export default function DistributorPanel() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activePage, setActivePage] = useState("dashboard");

//   const navigate = useNavigate();

//   // ✅ Protect the dashboard with session check
//   useEffect(() => {
//     const authUserData = sessionStorage.getItem("authUserData");
//     if (!authUserData) {
//       navigate("/login"); // redirect if not logged in
//     }
//   }, [navigate]);

//   const nav = [
//     { key: "dashboard", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
//     { key: "retailers", icon: <Users size={18} />, label: "Retailers" },
//     { key: "keys", icon: <KeyRound size={18} />, label: "Keys" },
//     { key: "inventory", icon: <Package size={18} />, label: "Inventory" },
//     { key: "orders", icon: <ClipboardList size={18} />, label: "Orders" },
//     { key: "invoices", icon: <FileText size={18} />, label: "Payments" },
//     { key: "balances", icon: <FileText size={18} />, label: "Balances" },
//     { key: "tickets", icon: <Ticket size={18} />, label: "Support" },
//     { key: "settings", icon: <Settings size={18} />, label: "Account" },
//   ];

//   return (
//     <div className="min-h-screen bg-white text-slate-900">
//       {/* Top Bar */}
//       <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: "#104191ff" }}>
//         <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//           <div className="flex h-14 items-center justify-between">
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => setSidebarOpen((s) => !s)}
//                 className="rounded-xl p-2 hover:bg-white/10 focus:outline-none"
//                 aria-label="Toggle sidebar"
//               >
//                 <Menu className="text-white" size={20} />
//               </button>
//               <img src={LOGO_URL} alt="Logo" className="h-8 w-auto" />
//               <span className="ml-1 text-sm font-semibold tracking-wide text-white/80">
//                 Distributor Panel
//               </span>
//             </div>

//             <div className="flex items-center gap-1 sm:gap-2">
//               <button className="relative rounded-xl p-2 hover:bg-white/10">
//                 <Bell className="text-white" size={18} />
//                 <span
//                   className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full text-[10px]"
//                   style={{ backgroundColor: "#E11D48", color: "#FFFFFF" }}
//                 >
//                   3
//                 </span>
//               </button>
//               <button
//                 onClick={() => setActivePage("settings")}
//                 className="group flex items-center gap-2 rounded-xl bg-white/10 px-2 py-1.5 text-white hover:bg-white/20"
//                 title="Open Profile"
//               >
//                 <div className="h-6 w-6 overflow-hidden rounded-full bg-white/20" />
//                 <span className="text-sm">Profile</span>
//                 <ChevronDown size={16} className="opacity-80" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Layout */}
//       <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-12 gap-3 sm:gap-4 py-3 sm:py-4">
//           {/* Sidebar */}
//           {sidebarOpen && (
//             <aside className="col-span-12 sm:col-span-4 lg:col-span-2">
//               <div className="sticky top-16 space-y-2 rounded-2xl p-2 bg-slate-50">
//                 {nav.map((n) => (
//                   <button
//                     key={n.key}
//                     onClick={() => {
//                       setActivePage(n.key);
//                       setSidebarOpen(false);
//                     }}
//                     className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left text-sm hover:bg-white ${
//                       activePage === n.key ? "bg-white" : ""
//                     }`}
//                   >
//                     <span className="text-slate-700">{n.icon}</span>
//                     <span className="text-slate-700">{n.label}</span>
//                   </button>
//                 ))}
//                 <div
//                   className="rounded-xl p-3 text-xs"
//                   style={{ backgroundColor: "#0B5ED7", color: "#FFFFFF" }}
//                 >
//                   <b>Tip:</b> Mobile-friendly. Use the menu to switch pages.
//                 </div>
//               </div>
//             </aside>
//           )}

//           {/* Content */}
//           <main
//             className={
//               sidebarOpen ? "col-span-12 sm:col-span-8 lg:col-span-10" : "col-span-12"
//             }
//           >
//             <div className="mb-3 flex sm:hidden items-center rounded-xl bg-slate-100 px-3 py-2">
//               <Search size={16} className="text-slate-500" />
//               <input
//                 placeholder="Search retailers, orders, keys…"
//                 className="ml-2 w-full bg-transparent text-sm focus:outline-none"
//               />
//             </div>

//             {activePage === "dashboard" && <Dashboard />}
//             {activePage === "retailers" && <Retailers />}
//             {activePage === "keys" && <Keys />}
//             {activePage === "inventory" && <Inventory />}
//             {activePage === "orders" && <Orders />}
//             {activePage === "invoices" && <Payments />}
//             {activePage === "balances" && <Balances />}
//             {activePage === "tickets" && <Support />}
//             {activePage === "settings" && <Account />}
//           </main>
//         </div>
//       </div>

//       <footer className="mt-4 sm:mt-6 border-t py-4 text-center text-xs text-slate-500">
//         © {new Date().getFullYear()} Goelectronix — Distributor Panel
//       </footer>
//     </div>
//   );
// }


// ****************************** 25 SEPT 2025 ORIGINAL CODE PHASE 1 ****************************************************************

// import { useState } from "react";
// import {
//   Menu, Search, Bell, ChevronDown, LayoutDashboard, Users, KeyRound, Package,
//   ClipboardList, FileText, Ticket, Settings
// } from "lucide-react";
// // import { motion } from "framer-motion";
// import Dashboard from "./Dashboard";
// import Retailers from "./Retailers";
// import Keys from "./Keys";
// import Account from "./Account";
// import Inventory from "./Inventory";
// import Orders from "./Orders";
// import Payments from "./Payment";
// import Balances from "./Balances";
// import Support from "./Support";
// // =====================================
// // Distributor Panel – Full Feature Set (Mobile-first, Light Theme)
// // JavaScript version (no TypeScript types)
// // =====================================
// // Brand colors
// //   Primary Blue:   #0B5ED7
// //   Dark Blue:      #0A3E91
// //   Accent Red:     #E11D48
// //   Neutral White:  #FFFFFF

// const LOGO_URL = "https://via.placeholder.com/140x40?text=LOGO"; // <-- replace with your logo link

// export default function DistributorPanel() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activePage, setActivePage] = useState("dashboard");

//   const nav = [
//     { key: "dashboard", icon: <LayoutDashboard size={18} />, label: "Dashboard" },
//     { key: "retailers", icon: <Users size={18} />, label: "Retailers" },
//     { key: "keys", icon: <KeyRound size={18} />, label: "Keys" },
//     { key: "inventory", icon: <Package size={18} />, label: "Inventory" },
//     { key: "orders", icon: <ClipboardList size={18} />, label: "Orders" },
//     { key: "invoices", icon: <FileText size={18} />, label: "Payments" },
//     { key: "balances", icon: <FileText size={18} />, label: "Balances" },
//     { key: "tickets", icon: <Ticket size={18} />, label: "Support" },
//     { key: "settings", icon: <Settings size={18} />, label: "Account" },
//   ];

//   return (
//     <div className="min-h-screen bg-white text-slate-900">
//       {/* Top Bar */}
//       <header className="sticky top-0 z-40 shadow-sm" style={{ backgroundColor: "#104191ff" }}>
//         <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//           <div className="flex h-14 items-center justify-between">
//             <div className="flex items-center gap-2">
//               <button
//                 onClick={() => setSidebarOpen((s) => !s)}
//                 className="rounded-xl p-2 hover:bg-white/10 focus:outline-none"
//                 aria-label="Toggle sidebar"
//               >
//                 <Menu className="text-white" size={20} />
//               </button>
//               <img src={LOGO_URL} alt="Logo" className="h-8 w-auto" />
//               <span className="ml-1 text-sm font-semibold tracking-wide text-white/80">Distributor Panel</span>
//             </div>

//             <div className="flex items-center gap-1 sm:gap-2">
//               <button className="relative rounded-xl p-2 hover:bg-white/10">
//                 <Bell className="text-white" size={18} />
//                 <span
//                   className="absolute -right-0.5 -top-0.5 inline-flex h-4 min-w-[16px] items-center justify-center rounded-full text-[10px]"
//                   style={{ backgroundColor: "#E11D48", color: "#FFFFFF" }}
//                 >
//                   3
//                 </span>
//               </button>
//               <button
//                 onClick={() => setActivePage("settings")}
//                 className="group flex items-center gap-2 rounded-xl bg-white/10 px-2 py-1.5 text-white hover:bg-white/20"
//                 title="Open Profile"
//               >
//                 <div className="h-6 w-6 overflow-hidden rounded-full bg-white/20" />
//                 <span className="text-sm">Profile</span>
//                 <ChevronDown size={16} className="opacity-80" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {/* Main Layout */}
//       <div className="mx-auto max-w-7xl px-3 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-12 gap-3 sm:gap-4 py-3 sm:py-4">
//           {/* Sidebar */}
//           {sidebarOpen && (
//             <aside className="col-span-12 sm:col-span-4 lg:col-span-2">
//               <div className="sticky top-16 space-y-2 rounded-2xl p-2 bg-slate-50">
//                 {nav.map((n) => (
//                   <button
//                     key={n.key}
//                     onClick={() => {
//                       setActivePage(n.key);
//                       setSidebarOpen(false);
//                     }}
//                     className={`flex w-full items-center gap-2 rounded-xl px-3 py-2 text-left text-sm hover:bg-white ${activePage === n.key ? "bg-white" : ""}`}
//                   >
//                     <span className="text-slate-700">{n.icon}</span>
//                     <span className="text-slate-700">{n.label}</span>
//                   </button>
//                 ))}
//                 <div className="rounded-xl p-3 text-xs" style={{ backgroundColor: "#0B5ED7", color: "#FFFFFF" }}>
//                   <b>Tip:</b> Mobile-friendly. Use the menu to switch pages.
//                 </div>
//               </div>
//             </aside>
//           )}

//           {/* Content */}
//           <main className={sidebarOpen ? "col-span-12 sm:col-span-8 lg:col-span-10" : "col-span-12"}>
//             {/* Search (mobile-visible) */}
//             <div className="mb-3 flex sm:hidden items-center rounded-xl bg-slate-100 px-3 py-2">
//               <Search size={16} className="text-slate-500" />
//               <input placeholder="Search retailers, orders, keys…" className="ml-2 w-full bg-transparent text-sm focus:outline-none" />
//             </div>

//             {activePage === "dashboard" && <Dashboard />}
//             {activePage === "retailers" && <Retailers />}
//             {activePage === "keys" && <Keys />}
//             {activePage === "inventory" && <Inventory />}
//             {activePage === "orders" && <Orders />}
//             {activePage === "invoices" && <Payments />}
//             {activePage === "balances" && <Balances />}
//             {activePage === "tickets" && <Support />}
//             {activePage === "settings" && <Account />}
//           </main>
//         </div>
//       </div>

//       <footer className="mt-4 sm:mt-6 border-t py-4 text-center text-xs text-slate-500">© {new Date().getFullYear()} Goelectronix — Distributor Panel</footer>
//     </div>
//   );
// }